import axios from 'axios'

export default {
    getClassClassification(){
        return axios.get('/class-classification')
            .then(response => {
                return response.data
            })
    },
    getClassClassificationDataSource(params){
        return axios.get('/class-classification/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getClassClassificationbyID(id){
        return axios.get('/class-classification/' + id)
            .then(response => {
                return response.data
            })
    },    
    createClassClassification(formdata){
        return axios.post('/class-classification', formdata)
            .then(response => {
                return response.data
            })
    },
    updateClassClassification(id,formdata){
        return axios.put('/class-classification/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateClassClassification(id){
        return axios.put('/class-classification/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateClassClassification(id){
        return axios.put('/class-classification/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    
}